export default "__VITE_ASSET__CObKo41q__"